import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const HorizontalTemplateOneOneFive = ({
  titleText = "ONE OF\nA KIND",
  titleFont = "Helvetica",
  titleFontSize = "32",
  titleColor = "#E6E7EB",
  titleTextAlign = "left",
  titleIsBold = true,
  titleIsItalic = false,
  titleIsUnderline = false,
  titleUppercase = false,

  subtitleText = "Two reasons to buy it",
  subtitleFont = "Helvetica",
  subtitleFontSize = "14",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "center",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  backgroundType = "color",
  backgroundColor = "#0B0F14",
  backgroundImage = null,

  buttonLabel = "More Info",
  buttonFont = "Helvetica",
  buttonIsBold = true,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "14",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#C03BFF",

  contentImageLeft = "/oneoneFiveCar.png",
  contentImageRight = "/oneoneFiveBottom.png",

  backgroundImagePreview,

  inmeeting = false,
  position = null,
  preview = false,
  onClose,
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  return (
    <div
      className={`relative ${
        !inmeeting
          ? "h-auto"
          : ["top", "bottom"].includes(position)
          ? "h-[150px]"
          : "!h-[89vh] mt-[5%]"
      } w-full flex flex-row mx-auto items-center overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Left image */}
      <div
        className="flex-none w-1/6 min-h-[60px]"
        style={{
          backgroundImage: `url(${contentImageLeft})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Center panel */}
      <div
        className="w-4/6 flex-1 flex items-center justify-between gap-4 md:gap-8 px-4 md:px-8"
        style={{ backgroundColor }}
      >
        <div className="flex-shrink-0">
          <h1
            className={`whitespace-pre-line ${
              explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
            } ${titleUppercase ? "uppercase" : ""}`}
            style={{
              color: titleColor,
              fontSize: `${titleFontSize}px`,
              fontFamily: titleFont,
              textAlign: titleTextAlign,
              lineHeight: "1.05",
            }}
          >
            {titleText}
          </h1>
        </div>

        <div className="flex-1 flex justify-center">
          <div
            className={`inline-block text-center ${
              explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
            }`}
            style={{
              color: subtitleColor,
              fontSize: `${subtitleFontSize}px`,
              fontFamily: subtitleFont,
              textAlign: subtitleTextAlign,
              opacity: 0.95,
            }}
          >
            {subtitleText}
          </div>
        </div>

        <div className="flex-shrink-0">
          <button
            className={`px-5 py-2 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl ${
              buttonLink ? "cursor-pointer" : "cursor-default"
            }`}
            style={{
              backgroundColor: buttonBackgroundColor,
              color: buttonFontColor,
              fontSize: `${buttonFontSize}px`,
              fontFamily: buttonFont,
              fontWeight: explicitBoleanCheck(buttonIsBold) ? "bold" : "normal",
              fontStyle: explicitBoleanCheck(buttonIsItalic)
                ? "italic"
                : "normal",
              textDecoration: explicitBoleanCheck(buttonIsUnderline)
                ? "underline"
                : "none",
            }}
            onClick={() => {
              if (buttonLink) {
                window.open(buttonLink, "_blank");
              }
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>

      {/* Right image */}
      <div
        className="flex-none w-1/6 min-h-[60px]"
        style={{
          backgroundImage: `url(${contentImageRight})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
    </div>
  );
};

export default HorizontalTemplateOneOneFive;


